<template>
  <div class="footer_menu">
    <span v-for="menu in menus" :key="menu.label">
      <FooterMenu
        :url="menu.url"
        :image="menu.image"
        :label="menu.label"
        :cartItemCount="menu.label === 'Cart' ? cartItemCount : 0"
        @handleClick="handleClick"
      />
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FooterMenu from '@/components/atoms/FooterMenu.vue';

export default {
  components: {
    FooterMenu,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      // Xmarket機能廃止
      // currentPage: 'market/currentPage',
      // isCartOpen: 'market/isCartOpen',
      // marketCartList: 'market/resultMarketCartList',
    }),
    // Xmarket機能廃止
    // isMarketPage() {
    //   return this.$route.path === '/market';
    // },
    // cartItemCount() {
    //   if (this.marketCartList && this.marketCartList.list.length) {
    //     return this.marketCartList.list.length;
    //   }
    //   return 0;
    // },
    menus() {
      return [
        {
          url: '/',
          image: '/img/menu/home.png',
          label: 'HOME',
        },
        {
          url: '/store',
          image: '/img/menu/SHOP.png',
          label: 'SHOP',
          isTransition: true,
        },
        {
          url: '/buy-point',
          image: '/img/star_coin.webp',
          label: 'Coin',
        },
        {
          url: '/purchase-card',
          image: '/img/menu/purchase.png',
          label: 'Sell To us',
          isTransition: true,
        },
        {
          url: '/rewards',
          image: '/img/menu/rewards.png',
          label: 'Rewards',
          isTransition: true,
        },
        {
          url: '',
          image: '/img/menu/mypage.png',
          label: 'My Page',
          isTransition: false,
        },
      ];
    },
  },

  // data: () => ({
  //   menus: [
  //     {
  //       url: '/',
  //       image: '/img/menu/home.png',
  //       label: 'HOME',
  //     },
  //     {
  //       url: '/store',
  //       image: '/img/menu/gtchaxplus.png',
  //       label: 'GTCHA+',
  //       isTransition: true,
  //     },
  //     {
  //       url: '/buy-point',
  //       image: '/img/star_coin.png',
  //       label: 'Coin',
  //     },
  //     // TODO
  //     {
  //       // url: '/purchase-card',// 公開時に変更
  //       url: 'https://xeroplace.jp/selltouscominsoon',
  //       image: '/img/menu/purchase.png',
  //       label: 'Sell To us',
  //       isTransition: true,
  //     },
  //     // TODO
  //     {
  //       url: this.isMarketPage ? '' : '/market',
  //       image: this.isMarketPage ? '/img/menu/cart.png' : '/img/menu/Xmarket.png',
  //       label: this.isMarketPage ? 'Cart' : 'X Market',
  //       isTransition: !this.isMarketPage,
  //     },
  //     // TODO
  //     {
  //       url: '',
  //       image: '/img/menu/mypage.png',
  //       label: 'My Page',
  //       isTransition: false,
  //     },
  //   ],
  // }),

  methods: {
    handleClick(label) {
      if (label === 'My Page') {
        this.$store.dispatch('user/setShowMyPage', true);
      }
      // Xmarket機能廃止
      // else if (label === 'Cart') {
      //   this.$store.dispatch('market/toggleCart');
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.footer_menu {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1000;
  width: -webkit-fill-available;
  z-index: 1;
  background-color: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 5px;
  padding: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 2.1);
  z-index: 10;
}
</style>
